import { useEffect } from "preact/compat"
import { LoadingSpinner } from "@/app/loading"

interface OAuthRedirectModalProps {
  name: string
  redirectUrl: string
}

export function OAuthRedirectModal({ name, redirectUrl }: OAuthRedirectModalProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = redirectUrl
    }, 2000)
    return () => clearTimeout(timer)
  }, [redirectUrl])

  return (
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg p-8 max-w-sm w-full mx-4 text-center flex flex-col items-center">
        <LoadingSpinner />
        <p class="mt-4 text-lg font-medium text-gray-900">
          Taking you to {name}...
        </p>
      </div>
    </div>
  )
}
